<template>
  <el-card>
    <section>
      <!--工具条-->
      <el-col :span="24" class="form-line">
        <el-form size="small" :inline="true" :model="filters">
          <el-form-item label="真实姓名">
            <el-input v-model="filters.realName" placeholder="请输入真实姓名"></el-input>
          </el-form-item>
          <el-form-item label="联系电话">
            <el-input v-model="filters.mobile" placeholder="请输入联系电话"></el-input>
          </el-form-item>
          <el-form-item label="所属机构">
            <el-input v-model="filters.deptName" placeholder="请输入所属机构"></el-input>
          </el-form-item>
          <el-form-item label="用户类型">
            <el-select clearable v-model="filters.userType" placeholder="请选择用户类型">
              <el-option
                  v-for="item in userTypeList"
                  :key="item.dictKey"
                  :label="item.name"
                  :value="item.dictKey">
              </el-option>
            </el-select>
          </el-form-item>
          <div style="float: right">
            <el-form-item>
              <el-button type="primary" plain @click="changeSearchType">
                筛选
                <i v-if="searchType == 1" class="el-icon-arrow-down el-icon"></i>
                <i v-if="searchType == 2" class="el-icon-arrow-up el-icon"></i>
              </el-button>
            </el-form-item>
            <el-form-item>
              <el-button-group>
                <el-button type="primary" icon="el-icon-search" @click="getUsers()">查询</el-button>
                <el-button icon="el-icon-refresh-right" @click="resetFilter()">重置</el-button>
              </el-button-group>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-download" @click="downloadUser()">批量导出</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="handleAdd">新增</el-button>
            </el-form-item>
          </div>
        </el-form>
      </el-col>
      <el-col :span="24" class="form-line" v-if="searchType == 2">
        <el-form size="small" :inline="true" :model="filters">
          <!--          <el-form-item label="所在科室">-->
          <!--            &lt;!&ndash;            <el-input v-model="filters.street" placeholder="请输入所在科室"></el-input>&ndash;&gt;-->
          <!--            <el-select clearable v-model="filters.street" placeholder="请选择所在科室">-->
          <!--              <el-option-->
          <!--                  v-for="item in streetList"-->
          <!--                  :key="item.dictKey"-->
          <!--                  :label="item.name"-->
          <!--                  :value="item.dictKey">-->
          <!--              </el-option>-->
          <!--            </el-select>-->
          <!--          </el-form-item>-->
<!--          <el-form-item label="职务">-->
<!--            <el-input v-model="filters.community" placeholder="请输入职务"></el-input>-->
<!--          </el-form-item>-->
          <el-form-item label="地址">
            <el-input v-model="filters.address" placeholder="请输入地址"></el-input>
          </el-form-item>
          <el-form-item label="角色" v-if="type === 3">
            <el-select clearable v-model="filters.roleId" placeholder="请选择角色">
              <el-option
                  v-for="item in sysRoleList"
                  :key="item.id"
                  :label="item.roleName"
                  :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </el-col>
      <!--列表-->
      <el-table border size="medium" :data="users" highlight-current-row v-loading="listLoading">
        <el-table-column type="index" min-width="60">
        </el-table-column>
        <el-table-column prop="userName" label="用户名" min-width="100">
        </el-table-column>
        <el-table-column prop="userType" label="用户类型" min-width="100" :formatter="fmt_userType">
        </el-table-column>
        <el-table-column prop="realName" label="真实姓名" min-width="100">
        </el-table-column>
        <el-table-column prop="mobile" label="联系电话" min-width="120">
        </el-table-column>
        <!--        <el-table-column prop="street" label="所在科室" min-width="100" :formatter="fmt_street">-->
        <!--        </el-table-column>-->
        <el-table-column prop="deptName" label="所属机构" min-width="100">
        </el-table-column>
        <el-table-column prop="address" label="额外管辖区域" min-width="180">
        </el-table-column>
        <el-table-column prop="userRoleNames" label="角色" min-width="180">
        </el-table-column>
        <el-table-column label="操作" min-width="180">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button type="text"  size="small" @click="handleRole(scope.row)">角色分配
            </el-button>
            <el-button type="text"  size="small" @click="handReset(scope.row)">重置密码
            </el-button>
            <el-button type="text" size="small" @click="handDel(scope.row)">删除</el-button>
            <el-button v-if="scope.row.handsetId!=null&&scope.row.handsetId!=''" type="text" size="small"
                       @click="handHandsetId(scope.row)">
              解除设备绑定
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--工具条-->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="padding: 15px 5px">
      </el-pagination>

      <!--编辑界面-->
      <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
        <el-form size="small" :model="editForm" label-width="120px" :rules="editFormRules" ref="editForm">
          <el-form-item label="登录账号" prop="userName">
            <el-input v-model="editForm.userName" maxlength="20" :readOnly="!addUserFlag"
                      auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="用户类型">
            <el-select clearable v-model="editForm.userType" placeholder="请选择用户类型">
              <el-option
                      v-for="item in userTypeList"
                      :key="item.dictKey"
                      :label="item.name"
                      :value="item.dictKey">
              </el-option>
            </el-select>
          </el-form-item>
            <el-form-item label="所属机构" prop="deptId">
              <el-row>
                <el-col :span="12">
                  <el-input v-model="editForm.deptName" readOnly auto-complete="off"></el-input>
                </el-col>
                <el-col :span="12">
                  <el-button type="text" size="small" @click="toChooseDept()">选择机构</el-button>
                </el-col>
              </el-row>
            </el-form-item>
          <el-form-item label="姓名" prop="realName">
            <el-input v-model="editForm.realName" maxlength="20" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="身份证号" prop="idCard">
            <el-input v-model="editForm.idCard" maxlength="20" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="性别">
            <el-radio-group v-model="editForm.userSex">
              <el-radio class="radio" :label="1">男</el-radio>
              <el-radio class="radio" :label="2">女</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="手机号" prop="mobile">
            <el-input v-model="editForm.mobile" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="额外管辖区域">
            <el-input type="textarea" v-model="editForm.address" maxlength="100"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click.native="editFormVisible = false">取消</el-button>
          <el-button size="small" type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <el-dialog :title="sysRoleTitle" :visible.sync="sysRoleVisible" :close-on-click-modal="false">
        <el-form size="small" label-width="160px">
          <el-form-item label="角色分配">
            <el-checkbox-group v-model="checkedRoles" @change="checkFgldRight">
              <el-checkbox v-for="item in sysRoleList" :label="item.id" :key="item.id">{{ item.roleName }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="分管领导管辖科室" v-if="fgldFlag">
            <el-checkbox-group v-model="managerOrgs">
              <el-checkbox v-for="item in orgList" :label="item.dictKey" :key="item.dictKey">{{ item.name }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click.native="sysRoleVisible = false">取消</el-button>
          <el-button size="small" type="primary" @click.native="addUserRole" :loading="editLoading">提交</el-button>
        </div>
      </el-dialog>

      <!--选择机构弹窗-->
      <el-dialog title="选择机构" :visible.sync="chooseDeptVisible" :close-on-click-modal="false">
        <el-row :gutter="20">
          <el-col :span="24">
            <div class="custom-tree-container">
              <div class="block">
                <el-tree
                    :data="deptData"
                    node-key="id"
                    default-expand-all
                    :expand-on-click-node="false"
                    :props="treeProps"
                    show-checkbox
                    check-strictly
                    @check-change="checkChange"
                    ref="tree">
                  <template #default="{ node, data }">
                  <span class="custom-tree-node">
                    <span>{{ node.label }}</span>
                  </span>
                  </template>
                </el-tree>
              </div>
            </div>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click.native="chooseDeptVisible = false">取消</el-button>
          <el-button size="small" type="primary" @click.native="changeDept" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>
    </section>
  </el-card>
</template>

<script>
/* eslint-disable */
import { doPost, download } from '../../api/api'
import ElRow from 'element-ui/packages/row/src/row'
import ElCol from 'element-ui/packages/col/src/col'
import {validatorPhone,validatorIdCard } from '../../api/util'
export default {
  components: { ElCol, ElRow },
  data () {
    return {
      userTypeList: [],
      streetList: [],
      filters: {
        realName: '',
        mobile: '',
        street: '',
        community: '',
        address: '',
        roleId: '',
        deptName: '',
        userType: ''
      },
      users: [],
      total: 0,
      listLoading: false,
      editFormVisible: false, // 编辑界面是否显示
      editLoading: false,
      editFormRules: {
        userName: [
          { required: true, message: '请输入账号', trigger: 'blur' }
        ],
        userType: [
          { required: true, message: '请选择用户类型', trigger: 'blur' }
        ],
        realName: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        idCard: [
          { required: true,validator: validatorIdCard, trigger: 'blur' }
        ]
      },
      // 编辑界面数据
      editForm: {
        id: '',
        userName: '',
        deptId: '',
        deptName: '',
        realName: '',
        idCard: '',
        mobile: '',
        userSex: 1,
        street: '',
        community: '',
        address: ''
      },
      deptData: [],
      treeProps: { label: 'deptName', children: 'sonList' },
      chooseDeptVisible: false,
      addLoading: false,
      sysRoleList: [],
      orgList: [],
      sysRoleVisible: false,
      sysRoleTitle: '',
      type: 1, // 1-用户管理 3-角色用户
      sysUserRole: {
        id: '',
        userId: '',
        roleId: ''
      },
      checkedRoles: [],
      managerOrgs: [],
      changeUserId: '',
      addUserFlag: false,
      searchType: 1,
      fgldFlag: false
    }
  },
  methods: {
    getUserType () {
      let para = { dictType: 'user_type' }
      doPost('/sysDict/getAllList', para).then(res => {
        this.userTypeList = res.result
      })
    },
    fmt_street (obj) {
      console.log(obj.street)
      if (this.streetList !== null && this.streetList.length > 0) {
        for (var a = 0; a < this.streetList.length; a++) {
          if (this.streetList[a].dictKey === obj.street) {
            return this.streetList[a].name
          }
        }
      }
    },
    checkFgldRight () {
      var flag = false
      for (var i = 0; i < this.checkedRoles.length; i++) {
        if (this.checkedRoles[i] === '3') {
          flag = true
        }
      }
      if (flag) {
        this.fgldFlag = true
      } else {
        this.fgldFlag = false
      }
    },
    changeSearchType () {
      if (this.searchType === 1) {
        this.searchType = 2
      } else {
        this.searchType = 1
      }
    },
    // 性别显示转换
    formatSex: function (row, column) {
      return row.userSex === 1 ? '男' : row.userSex === 2 ? '女' : '未知'
    },
    handleSizeChange (val) {
      this.filters.pageSize = val
      this.getUsers()
    },

    handleCurrentChange (val) {
      this.filters.pageNum = val
      this.getUsers()
    },
    resetFilter () {
      Object.assign(this.$data.filters, this.$options.data().filters)
    },
    // 获取用户列表
    getUsers () {
      this.loading = true
      //      var para = {
      //        realName: this.filters.realName,
      //        mobile: this.filters.mobile,
      //        'sysRole.systemFlag': 'service-mdinfo',
      //        street: this.filters.street,
      //        community: this.filters.community,
      //        address: this.filters.address,
      //        'sysRole.id': this.filters.roleId
      //      }
      var para = this.filters
      doPost('/sysUser/getPageList', para).then((res) => {
        this.total = res.result.total
        this.users = res.result.list
        this.loading = false
      })
    },
    downloadUser () {
      // axios下载数据
      var para = {
        realName: this.filters.realName,
        mobile: this.filters.mobile,
        street: this.filters.street,
        community: this.filters.community,
        address: this.filters.address,
        'sysRole.id': this.filters.roleId
      }
      download('/sysUser/downloadUser', para, '用户数据.xls')
    },
    /* 删除 */
    handDel (obj) {
      var para = {
        id: obj.id
      }
      this.$confirm('是否删除，操作后无法恢复, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        doPost('/sysUser/delete', para).then(res => {
          console.log(res)
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '已删除'
            })
            this.getUsers()
          }
        })
      })
    },
    // /*重置密码*/
    handReset (obj) {
      var para = {
        id: obj.id
      }
      this.$confirm('是否重置密码，操作后无法恢复, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        doPost('/sysUser/resetPwd', para).then(res => {
          console.log(res)
          if (res.code === 0) {
            this.$alert(res.result, '新密码', {
              confirmButtonText: '确定'
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消重置密码'
        })
      })
    },
    handHandsetId (obj) {
      var para = {
        id: obj.id, handsetId: ''
      }
      this.$confirm('是否解除设备绑定，操作后无法恢复, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        doPost('/sysUser/updHandsetId', para).then(res => {
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '已成功解除设备绑定'
            })
            this.getUsers()
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消解除微信绑定'
        })
      })
    },
    // /*解除微信绑定*/
    handRelieve (obj) {
      var para = {
        id: obj.id
      }
      this.$confirm('是否解除微信绑定，操作后无法恢复, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        doPost('/sysUser/relieve', para).then(res => {
          if (res.code === 0) {
            this.$message({
              type: 'success',
              message: '已成功解除微信绑定'
            })
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消解除微信绑定'
        })
      })
    },
    fmt_userType (obj) {
      let res = ''
      this.userTypeList.forEach(function (item) {
        if (item.dictKey == obj.userType) {
          res = item.name
        }
      })
      return res
    },
    handleRole (sysUser) {
      this.checkedRoles = []
      this.managerOrgs = []
      this.fgldFlag = false
      this.sysRoleTitle = '角色分配'
      console.log(sysUser)
      if (sysUser.userRoleStr !== null) {
        var userRoles = sysUser.userRoleStr.split(',')
        for (var i = 0; i < userRoles.length; i++) {
          if (userRoles[i] === '3') {
            // 包含分管领导权限
            this.fgldFlag = true
          }
          this.checkedRoles.push(userRoles[i])
        }
        if (this.fgldFlag && sysUser.managerOrgs != null) {
          var orgs = sysUser.managerOrgs.split(',')
          for (var j = 0; j < orgs.length; j++) {
            this.managerOrgs.push(orgs[j])
          }
        }
      }
      this.changeUserId = sysUser.id
      this.sysRoleVisible = true
    },
    getRoleList () {
      var para = {
        systemFlag: 'service-mdinfo'
      }
      doPost('/sysRole/getAllList', para).then(res => {
        this.sysRoleList = res.result
      })
    },
    toChooseDept () {
      // 选择机构
      if (this.addUserFlag) {
        this.chooseDeptVisible = true
        this.$nextTick(() => {
          this.$refs.tree.setCheckedKeys([])
        })
      } else {
        if (this.editForm.deptId !== null && this.editForm.deptId !== '') {
          this.chooseDeptVisible = true
          this.$nextTick(() => {
            this.$refs.tree.setCheckedKeys([this.editForm.deptId])
          })
        } else {
          this.chooseDeptVisible = true
        }
      }
    },
    checkChange (node, checkFlag, sonCheckFlag) {
      //      console.log(node.deptName)
      // 单选处理
      if (checkFlag) {
        this.$refs.tree.setCheckedNodes([node])
      }
    },
    changeDept () {
      var checkNodes = this.$refs.tree.getCheckedNodes()
      console.log(checkNodes)
      if (checkNodes.length > 0) {
        this.editForm.deptId = checkNodes[0].id
        this.editForm.deptName = checkNodes[0].deptName
      } else {
        this.editForm.deptId = ''
        this.editForm.deptName = ''
      }
      this.chooseDeptVisible = false
    },
    addUserRole () {
      var para = {
        id: this.changeUserId,
        userRoleStr: JSON.stringify(this.checkedRoles),
        managerOrgs: JSON.stringify(this.managerOrgs)
      }
      doPost('/sysUser/changeUserRole', para).then(res => {
        this.$message({
          message: '分配成功！',
          type: 'success'
        })
        this.sysRoleVisible = false
        this.getUsers()
      })
    },
    // 删除
    handleDel: function (index, row) {
      //      this.$confirm('确认删除该记录吗?', '提示', {
      //        type: 'warning'
      //      }).then(() => {
      //        this.listLoading = true
      //        //        let para = { id: row.id }
      //        //        removeUser(para).then((res) => {
      //        //          this.listLoading = false
      //        //          this.$message({
      //        //            message: '删除成功',
      //        //            type: 'success'
      //        //          })
      //        //          this.getUsers()
      //        //        })
      //      }).catch(() => {
      //
      //      })
    },
    // 显示编辑界面
    handleEdit: function (index, row) {
      var para = { id: row.id }
      doPost('/sysUser/getById', para).then((res) => {
        console.log(res.result)
        this.editForm = res.result
        this.editForm.userType = this.editForm.userType.toString()
        this.addUserFlag = false
        this.editFormVisible = true
      })
    },
    // 显示新增界面
    handleAdd: function () {
      Object.assign(this.$data.editForm, this.$options.data().editForm)
      this.addUserFlag = true
      this.editFormVisible = true
    },
    // 编辑
    editSubmit: function () {
      if (this.addUserFlag) {
        // 添加用户 校验用户名是否存在
        var para = {
          userName: this.editForm.userName
        }
        doPost('/sysUser/checkUserName', para).then(res => {
          if (res.result) {
            // 用户名已存在
            this.$message({
              message: '用户名已存在，请确认！',
              type: 'error'
            })
          } else {
            this.sureSubmit()
          }
        })
      } else {
        this.sureSubmit()
      }
    },
    sureSubmit () {
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {}).then(() => {
            this.editLoading = true
            var para = {
              id: this.editForm.id,
              userName: this.editForm.userName,
              userType: this.editForm.userType,
              realName: this.editForm.realName,
              deptId: this.editForm.deptId,
              deptName: this.editForm.deptName,
              idCard: this.editForm.idCard,
              mobile: this.editForm.mobile,
              userSex: this.editForm.userSex,
              street: this.editForm.street,
              community: this.editForm.community,
              address: this.editForm.address
            }
            doPost('/sysUser/saveOrUpdate', para).then(res => {
              if (res.code === 0) {
                this.editFormVisible = false
                this.editLoading = false
                // 修改成功  提示信息
                this.$message({
                  message: '修改成功',
                  type: 'success'
                })
                this.getUsers()
              }
            })
          })
        }
      })
    },
    // 新增
    addSubmit: function () {
      //      this.$refs.addForm.validate((valid) => {
      //        if (valid) {
      //          this.$confirm('确认提交吗？', '提示', {}).then(() => {
      //            this.addLoading = true
      //            // NProgress.start();
      //            let para = Object.assign({}, this.addForm)
      //            para.birth = (!para.birth || para.birth === '') ? '' : util.formatDate.format(new Date(para.birth), 'yyyy-MM-dd')
      //            //            addUser(para).then((res) => {
      //            //              this.addLoading = false
      //            //              // NProgress.done();
      //            //              this.$message({
      //            //                message: '提交成功',
      //            //                type: 'success'
      //            //              })
      //            //              this.$refs['addForm'].resetFields()
      //            //              this.addFormVisible = false
      //            //              this.getUsers()
      //            //            })
      //          })
      //        }
      //      })
    },
    // 获取机构树形结构
    getDeptList () {
      doPost('/dept/getSysDeptTree', this.filters).then((res) => {
        console.log(res.result)
        this.deptData = res.result
      })
    },
    streetListBind () {
      this.streetList = []
      var para = {
        dictType: 'sys_user_street',
        delFlag: 1
      }
      doPost('/sysDict/getAllList', para).then(res => {
        this.streetList = res.result
        console.log(this.streetList)
      })
    },
    getOrgList () {
      // 获取纠纷类型参数
      var para = {
        dictType: 'department_type',
        delFlag: 1
      }
      doPost('/sysDict/getAllList', para).then(res => {
        this.orgList = []
        var resObj = res.result
        for (var i = 0; i < resObj.length; i++) {
          if (resObj[i].dictKey !== '50') {
            this.orgList.push(resObj[i])
          }
        }
      })
    }
  },
  mounted () {
    this.streetListBind()
    this.getOrgList()
    this.getUsers()
    this.getRoleList()
    this.getUserType()
    this.getDeptList()
  }
}

</script>

<style scoped>

</style>
